import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    backgroundColor: $theme.colors.white,
    padding: '0 2rem',
    color: $theme.colors.black
}))
